import type { NumberFormatOptions } from 'next-intl';

const MINUTE_SECONDS = 60;
const HOUR_SECONDS = 3_600;
const DAY_SECONDS = 86_400;

/** A duration in seconds as `intl.number` arguments in its largest whole-ish unit ("12 minutes"). */
export function durationUnit(seconds: number): [number, NumberFormatOptions] {
  const [value, unit] =
    seconds >= DAY_SECONDS
      ? [seconds / DAY_SECONDS, 'day']
      : seconds >= HOUR_SECONDS
        ? [seconds / HOUR_SECONDS, 'hour']
        : [seconds / MINUTE_SECONDS, 'minute'];
  return [value, { style: 'unit', unit, unitDisplay: 'long', maximumFractionDigits: 0 }];
}
